import type { FC, PropsWithChildren } from 'react'
import { createContext, useContext } from 'react'

import {
  type LastUnreadMessage,
  useMessagePreview,
} from '@liveHelper/context/MessageChannelContext/useMessagePreview'

export type MessagePreviewContextProps = {
  lastUnreadMessage: LastUnreadMessage | undefined
  markLatestMessageAsRead: () => void
  dismissMessagePreview: () => void
  showMessagePreview: () => void
}

export const MessagePreviewContext = createContext<MessagePreviewContextProps>({
  lastUnreadMessage: undefined,
  markLatestMessageAsRead: () => null,
  dismissMessagePreview: () => null,
  showMessagePreview: () => null,
})

/** Provider component that loads the rrweb library when needed. */
export const MessagePreviewProvider: FC<PropsWithChildren> = ({ children }) => {
  const {
    lastUnreadMessage,
    markLatestMessageAsRead,
    dismissMessagePreview,
    showMessagePreview,
  } = useMessagePreview()

  return (
    <MessagePreviewContext.Provider
      value={{
        lastUnreadMessage,
        markLatestMessageAsRead,
        dismissMessagePreview,
        showMessagePreview,
      }}
    >
      {children}
    </MessagePreviewContext.Provider>
  )
}

/** @returns MessagePreviewContext */
export const useMessagePreviewContext = () => {
  return useContext(MessagePreviewContext)
}
